import React from 'react';

const Hyperlink = ({ href, children, target = '_blank', rel = 'noopener noreferrer', className = '' }) => {

  return (
    <a href={href} target={target} rel={rel} className={className}>
      {children}
    </a>
  );
};

export default Hyperlink;